import Class from './s-widget';
import './s-widget@.vue';

export default Class;